import React from 'react';
import { Navigate } from 'react-router-dom';
import { resolveAccessibleLandingPath } from 'access/routeAccess';
import { usePermissions } from 'access/usePermission';

/** Sends authenticated users to their first permitted route (or `/dashboard`). */
export default function AccessibleLandingRedirect() {
  const { can } = usePermissions();
  return <Navigate to={resolveAccessibleLandingPath(can, [])} replace />;
}
